import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';

type PatchPayload = {
  companyName?: string;
  tenantName?: string;
  frn?: string | null;
  registeredAddress?: string;
  trialEndDate?: string | null;
};

export const usePatchJoinRequest = (id: string) => {
  const queryClient = useQueryClient();
  const { mutateAsync, isPending, reset } = useMutation<{ data: unknown }, Error, PatchPayload>({
    mutationFn: patch => api.patch(`admin/join-requests/${id}`, patch),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin', 'join-requests'] });
    },
  });
  return { patchRequest: mutateAsync, isPending, reset };
};

export const useRejectJoinRequest = () => {
  const queryClient = useQueryClient();
  const { mutateAsync, isPending, reset } = useMutation<
    { data: unknown },
    Error,
    { id: string; reason?: string }
  >({
    mutationFn: ({ id, reason }) =>
      api.post(`admin/join-requests/${id}/reject`, { rejectionReason: reason }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin', 'join-requests'] });
    },
  });
  return { rejectRequest: mutateAsync, isPending, reset };
};

export const useApproveJoinRequest = () => {
  const queryClient = useQueryClient();
  const { mutateAsync, isPending, reset } = useMutation<
    { data: { companyId: string } },
    Error,
    string
  >({
    mutationFn: id =>
      api.post<{ companyId: string }>(`admin/join-requests/${id}/approve`, undefined, {
        timeoutMs: 120_000,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin', 'join-requests'] });
    },
  });
  return { approveRequest: mutateAsync, isPending, reset };
};
